import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Dialog,
  FormControl,
  FormGroup,
  TextField,
  withStyles
} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans } from "@lingui/macro";
import {
  cancelAppointment,
  confirmAccountCreation,
  getReturnedValue,
  saveInfosUser
} from "../../utils/fetcher";
import { connect } from "react-redux";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { translator } from "../../utils/i18n";
import { PHONE_ALLOWED_COUNTRIES } from "../../utils/constants";
import PhoneInput from "react-phone-number-input";
import metadataMobile from "libphonenumber-js/metadata.mobile.json";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import Link from "@material-ui/core/Link";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { goToBeginning } from "../../utils/scenario-manager";
import Tooltip from "@material-ui/core/Tooltip";
import Fade from "@material-ui/core/Fade";

const styles = () => ({
  dialog: {
    borderRadius: "15px",
    minWidth: "440px"
  }
});

class ConfirmationSms extends Component {
  state = {
    open: true,
    acceptCgu: false,
    acceptBonneVue: false,
    input1Ref: React.createRef(),
    input2Ref: React.createRef(),
    input3Ref: React.createRef(),
    input4Ref: React.createRef(),
    isShowPhone: false,
    phone: "",
    countryCallingCode: "",
    hideFormPhone: true,
    isChange: true
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.cancelAppointmentFunc();
    this.props.goToBeginningFunc();
  };

  handleChange = input => {
    this.setState({ isChange: !this.state.isChange });
    if (input) {
      input.current.focus();
    }
  };

  isDisabled = () => {
    if (this.props.toValidateToken) {
      return (
        !this.state.acceptCgu ||
        !this.state.acceptBonneVue ||
        (this.state.input1Ref && this.state.input1Ref.current.value === "") ||
        (this.state.input2Ref && this.state.input2Ref.current.value === "") ||
        (this.state.input3Ref && this.state.input3Ref.current.value === "") ||
        (this.state.input4Ref && this.state.input4Ref.current.value === "")
      );
    }
    return (
      !this.state.input1Ref.current ||
      this.state.input1Ref.current.value === "" ||
      (!this.state.input2Ref.current ||
        this.state.input2Ref.current.value === "") ||
      (!this.state.input3Ref.current ||
        this.state.input3Ref.current.value === "") ||
      (!this.state.input4Ref.current ||
        this.state.input4Ref.current.value === "")
    );
  };

  isDisabledPhoneCode = () => {
    if (this.props.toValidateToken) {
      return this.state.phone === "" || this.state.countryCallingCode === "";
    } else {
      return this.state.phone === "" || this.state.countryCallingCode === "";
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const code =
      this.state.input1Ref.current.value +
      this.state.input2Ref.current.value +
      this.state.input3Ref.current.value +
      this.state.input4Ref.current.value;
    this.props.confirmation(code);
  };

  onChecked = value => {
    this.setState({ [value]: !this.state[value] });
  };

  handleChangePhone = tel => {
    const phoneNumber = parsePhoneNumberFromString(tel || "");
    const telIsValid = phoneNumber ? phoneNumber.isValid() : false;
    if (telIsValid) {
      this.setState({
        phone: phoneNumber.format("NATIONAL").replace(/ /g, "")
      });
      this.setState({ countryCallingCode: phoneNumber.countryCallingCode });
    } else {
      this.setState({
        phone: ""
      });
      this.setState({ countryCallingCode: "" });
    }
  };

  showPhone = () => {
    this.setState({ isShowPhone: true });
  };

  changePhone = e => {
    e.preventDefault();
    let values = getReturnedValue("userInfo");
    values.tel = this.state.phone;
    values.indicatif = this.state.countryCallingCode;
    const userId = getReturnedValue("userId");
    this.props.saveInfosUserFunc(values, userId, true);
    this.setState({ isShowPhone: false });
    this.setState({ hideFormPhone: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="priority-dialog-title"
          open={this.state.open}
          disableBackdropClick={true}
          classes={{
            paper: classes.dialog
          }}
        >
          <Tooltip
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 600 }}
            title={translator()._("W_ALERT_PERDRE_RDV_CLOSE_DIALOG")}
          >
            <IconButton
              className="close-dialog"
              edge="start"
              color="inherit"
              onClick={this.handleClose}
              aria-label="close"
            >
              <CloseIcon className="white" />
            </IconButton>
          </Tooltip>
          <DialogTitle className="head-dialog" id="priority-dialog-title">
            <div className="title-dialog">
              <i className="material-icons">lock</i>
            </div>
          </DialogTitle>
          <div className="body-dialog dialog-s">
            <div className="sub-title-dialog">
              <Trans id="W_STEP_POPUP_CODE_ATTENTION" />
            </div>
            {this.props.message && (
              <div
                className="text-red align-center"
                dangerouslySetInnerHTML={{ __html: this.props.message }}
              />
            )}
            <div className="text-dialog">
              <Trans id="W_STEP_POPUP_CODE_POUR_VALIDER_VOTRE_COMPTE" />
              <div>
                <strong className="d-block">
                  {getReturnedValue("userInfo").tel}
                </strong>
                {this.state.hideFormPhone && (
                  <Link
                    component="button"
                    variant="body2"
                    onClick={this.showPhone}
                  >
                    {"(Modifier votre num de téléphone en cas d'erreur)"}
                  </Link>
                )}
              </div>
            </div>

            <form className="mt-20 form-sms">
              {this.state.isShowPhone && (
                <div className="wrap-phone">
                  <PhoneInput
                    className="intl-tel-input"
                    countries={PHONE_ALLOWED_COUNTRIES}
                    country={this.props.telDefault.toUpperCase()}
                    defaultCountry={this.props.telDefault.toUpperCase()}
                    international={false}
                    onChange={phone => this.handleChangePhone(phone)}
                    limitMaxLength={true}
                    metadata={metadataMobile}
                    value={getReturnedValue("userInfo").tel}
                    placeholder={`${translator()._(
                      "FORMULAIRE_TELEPHONE"
                    )} : 06 62 23 23 23`}
                  />
                </div>
              )}
              {!this.state.isShowPhone && (
                <>
                  <FormControl component="fieldset" className="full-width">
                    <FormGroup className="wrap-inputs-code">
                      <TextField
                        margin="normal"
                        required={true}
                        inputProps={{
                          maxLength: 1
                        }}
                        className="input-code"
                        onChange={e =>
                          this.handleChange(this.state.input2Ref, e)
                        }
                        autoFocus={true}
                        inputRef={this.state.input1Ref}
                      />
                      <TextField
                        margin="normal"
                        className="input-code"
                        required={true}
                        inputProps={{
                          maxLength: 1
                        }}
                        onChange={e =>
                          this.handleChange(this.state.input3Ref, e)
                        }
                        inputRef={this.state.input2Ref}
                      />
                      <TextField
                        margin="normal"
                        required={true}
                        inputProps={{
                          maxLength: 1
                        }}
                        className="input-code"
                        onChange={e =>
                          this.handleChange(this.state.input4Ref, e)
                        }
                        inputRef={this.state.input3Ref}
                      />
                      <TextField
                        margin="normal"
                        required={true}
                        inputProps={{
                          maxLength: 1
                        }}
                        className="input-code"
                        inputRef={this.state.input4Ref}
                        onChange={e => this.handleChange(null, e)}
                      />
                    </FormGroup>
                    {this.props.toValidateToken && (
                      <FormGroup className="mt-20 list-checkbox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={() => this.onChecked("acceptBonneVue")}
                              value="acceptBonneVue"
                            />
                          }
                          label={translator()._("W_STEP4_COCHE_LBV")}
                          checked={this.state.acceptBonneVue}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={() => this.onChecked("acceptCgu")}
                              value="acceptCgu"
                            />
                          }
                          label={translator()._("W_STEP4_COCHE_CGU")}
                          checked={this.state.acceptCgu}
                        />
                      </FormGroup>
                    )}
                  </FormControl>
                  {this.props.codeSms && (
                    <div className="confirm-sms text-error">
                      {this.props.codeSms}
                    </div>
                  )}
                </>
              )}
              <div className="wrap-btn d-flex justify-content-round">
                {this.state.isShowPhone ? (
                  <button
                    type="submit"
                    disabled={this.isDisabledPhoneCode()}
                    className="custom-btn m-0"
                    onClick={this.changePhone}
                  >
                    <Trans id="W_VALIDER" />
                  </button>
                ) : (
                  <button
                    type="submit"
                    disabled={this.isDisabled()}
                    className="custom-btn m-0"
                    onClick={this.handleSubmit}
                  >
                    <Trans id="W_VALIDER" />
                  </button>
                )}
              </div>
            </form>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

ConfirmationSms.propTypes = {
  cancelAppointmentFunc: PropTypes.func,
  classes: PropTypes.shape({
    dialog: PropTypes.any
  }),
  codeSms: PropTypes.any,
  confirmation: PropTypes.func,
  goToBeginningFunc: PropTypes.func,
  message: PropTypes.any,
  saveInfosUserFunc: PropTypes.func,
  toValidateToken: PropTypes.any,
  telDefault: PropTypes.string
};

const mapStateToProps = state => {
  return {
    message: state.message,
    tel:
      (state.returnedValue.userInfo && state.returnedValue.userInfo.tel) || "",
    toValidateToken: state.toValidateToken,
    telDefault: state.configuration.teldefaut || "FR"
  };
};

const mapDispatchToProps = dispatch => {
  return {
    cancelAppointmentFunc: () => dispatch(cancelAppointment()),
    confirmation: code => dispatch(confirmAccountCreation(code)),
    goToBeginningFunc: () => dispatch(goToBeginning()),
    saveInfosUserFunc: (values, userId, submitSms) =>
      dispatch(saveInfosUser(values, userId, submitSms))
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConfirmationSms)
);
